import updateCalendarEventsToDecline from '../actions/updateCalendarEventsToDecline';
import setStartTime from '../actions/setStartTime';
import { orchestrator } from 'satcheljs';
export default orchestrator(setStartTime, function (actionMessage) {
    var date = actionMessage.dateTime;
    if (date) {
        updateCalendarEventsToDecline();
    }
});
//# sourceMappingURL=onSetStartTimeOrchestrator.js.map